import Tracking from '../utils/tracking'

interface PersonCard {
  id: string
  personalityTraits: string
}

interface TraitCard {
  id: string
  description: string
}

// Initialise the data layer and fire the initial pageview exactly once, at
// module load time (NOT inside the hook body or a useEffect). This must stay
// top-level so first-paint timing is unaffected and the event isn't
// double-fired under React.StrictMode, and so the dataLayer array order a
// Cypress spec indexes by position isn't changed.
Tracking.start()
Tracking.trackEvent({ event: 'pageview' })

export interface UseTrackingResult {
  trackEvent: typeof Tracking.trackEvent
  formatCards: typeof Tracking.utils.formatCards
  trackDealCards: (actionType: string, person: PersonCard, trait: TraitCard) => void
  trackAnimationToggle: (animationDisabled: boolean) => void
}

export function useTracking(): UseTrackingResult {
  return {
    trackEvent: Tracking.trackEvent,
    formatCards: Tracking.utils.formatCards,
    trackDealCards: (actionType: string, person: PersonCard, trait: TraitCard) => {
      Tracking.trackEvent({
        event: `game.click.deal-${actionType}-cards`,
        person: Tracking.utils.formatCards('person', person),
        trait: Tracking.utils.formatCards('trait', trait),
      })
    },
    trackAnimationToggle: (animationDisabled: boolean) => {
      Tracking.trackEvent({
        event: 'game.click.animation',
        animation: animationDisabled ? 'on' : 'off',
      })
    },
  }
}
